$(document).ready(function(){
	
  $('.displayCurrency').each(function(){
    var prevContent = $(this).text();    
    $(this).html(ptNumber.sprintNumber(prevContent,0,true));
  });
  
  
});
